import { useEffect, useState } from 'react'
import { loadServerSnapshots } from '../utils/serverSnapshots.js'

const EMPTY = { pollOfTheDay: '', pollOfTheDayKind: '', billOfTheMoment: '', polls: {} }

// UX15/UX34/UX57: thin React wrapper around loadServerSnapshots().
// Fetches on mount, holds the resolved wrapper
// { pollOfTheDay, billOfTheMoment, polls } in state. Starts as the
// empty wrapper so callers can destructure unconditionally without
// guarding; a missing poll just returns undefined from polls[pollId],
// and unset hero fields are '' so Home.jsx renders no hero card.
export function useServerSnapshots() {
  const [snapshots, setSnapshots] = useState(EMPTY)
  useEffect(() => {
    let cancelled = false
    loadServerSnapshots().then((data) => {
      if (!cancelled) setSnapshots(data)
    })
    return () => { cancelled = true }
  }, [])
  return snapshots
}
